module.exports = __webpack_public_path__ + "b6ebc11da0af22b984cf3aed493be957.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/logo_s.png
// module id = 146
// module chunks = 0